<template>
	<div class="casBox">
		<div class="caseSbox"  v-for="(item,index) in caseList" :key="index">
			<div class="caseSbox1">
				<img :src="item.url" class="banLogo"/>
				<p class="shop-name">{{item.name}} </p>
				<p class="des">{{item.des}}</p>
				<div class="shop-footer">
					<div class="area">城市:{{item.city}}</div>
					<div class="selector">{{item.intro}}</div>
				</div>
			</div>
		</div>
		<div class="clear"></div>
		<div class="more">查看更多</div>
	</div>
</template>

<script>
export default {
	name:'caseBox',
	data(){
		return{
			caseList:[
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				},
				{
					url:'../assets/images/def/logo_nairuier@2x.png',
					name:'奈瑞儿',
					des:'美容连锁品牌，近200家全直营门店，为女性提供品质一致的专业服务',
					city:'深圳',
					intro:'美容美体'
				}
			]
		}
	}
}
</script>

<style>
	.clear{
		clear: both;
	}
	.more{
		margin: 40px auto;
		    display: block;
		    border: 1px solid #8557fa;
		    border-radius: 2px;
		    width: 140px;
		    height: 38px;
		    line-height: 38px;
		    text-align: center;
		    cursor: pointer;
		    color: #8557fa;
	}
	.casBox {
		width: 100%;
	}
	@media screen and (max-width:1200px) {
		.caseSbox {
			padding-left: 12px;
			padding-right: 12px;
			margin-top: 34px;
			float: left;
			width: 100%;
			box-sizing: border-box;
		}
	}
	@media screen and (min-width:1200px) {
		.caseSbox {
			padding-left: 12px;
			padding-right: 12px;
			margin-top: 34px;
			float: left;
			width: 33.333%;
			box-sizing: border-box;
		}
	}
	
	.caseSbox1{
		position: relative;
		overflow: hidden;
		padding: 0 20px;
		border: 1px solid #edeff3;
		height: 400px;
		background-color: #fff;
		cursor: pointer;
		float: left;
	}
	.des {
		text-align: center;
		color: #666;
		font-size: 12px;
	}
	.shop-footer{
		position: absolute;
		padding: 0 20px;
		left: 0;
		right: 0;
		bottom: 16px;
		line-height: 17px;
		overflow: hidden;
		zoom: 1;
	}
	.selector{
		float: right;
		width: 70px;
		text-align: center;
		font-size: 12px;
		border: 1px solid #e5e5e5;
		line-height: 18px;
		color: #999;
	}
	.area{
		float: left;
		line-height: 20px;
		color: #666;
		font-size: 12px;
	}

	.shop-name {
		font-size: 16px;
		color: #3b3a3e;
		text-align: center;
		margin-bottom: 16px;
	}

	.banLogo {
		background-image: url("../assets/images/def/logo_nairuier@2x.png");
		width: 80px;
		height: 80px;
		margin: 30px auto 56px;
		background-size: 100% 100%;
		border-radius: 50%;
	}
</style>
